import React from 'react';
import Navbar from '../components/Navbar'
import Configuracion from '../components/Configuracion';

const ConfiguracionPage= ()=> {
    return (
        <div>
            <Navbar />
            <Configuracion />
        </div>
    );
};

export default ConfiguracionPage